import "antd/lib/tooltip/style";
import _Tooltip from "antd/lib/tooltip";
import "antd/lib/input/style";
import _Input from "antd/lib/input";
import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _escapeRegExp from "lodash/escapeRegExp";
import _debounce from "lodash/debounce";
var __jsx = React.createElement;
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import "core-js/modules/es6.regexp.constructor.js";
import "core-js/modules/es6.string.starts-with.js";
import "core-js/modules/es6.array.slice.js";
import React, { useCallback } from 'react';
import fetchAPI from '../../../utils/http/fetchAPI';
import validateInput, { rules } from '../../../utils/validateInputs';

// Maps the UI projectType to its db `project.type` and a human-readable noun.
var projectTypeConfig = {
  experiments: {
    dbType: 'tertiary',
    noun: 'project'
  },
  secondaryAnalyses: {
    dbType: 'secondary',
    noun: 'run'
  },
  sampleLoadingTables: {
    dbType: 'samplelt',
    noun: 'table'
  }
};
var getProjectTypeConfig = function getProjectTypeConfig(projectType) {
  return projectTypeConfig[projectType] || projectTypeConfig.experiments;
};
var ProjectSearchBox = function ProjectSearchBox(props) {
  var onChange = props.onChange,
    projectType = props.projectType;
  var debouncedSetFilterParam = useCallback(_debounce(/*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(value) {
      var userPrefix, searchRegex, searchBy;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            userPrefix = 'user:'; // Escape the raw input so names/ids with regex metacharacters (e.g. "WT (rep 1)")
            // are matched literally instead of throwing and freezing the filter mid-type.
            searchRegex = new RegExp(_escapeRegExp(value), 'i');
            if (!value.startsWith(userPrefix)) {
              _context.next = 7;
              break;
            }
            searchBy = value.slice(userPrefix.length).trim();
            _context.next = 6;
            return getUserSearchRegex(searchBy, projectType);
          case 6:
            searchRegex = _context.sent;
          case 7:
            onChange(searchRegex);
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), 400), []);
  var _getProjectTypeConfig = getProjectTypeConfig(projectType),
    tooltipText = _getProjectTypeConfig.noun;
  return __jsx(_Tooltip, {
    title: "To search, insert ".concat(tooltipText, " name or ").concat(tooltipText, " ID here"),
    placement: "right"
  }, __jsx(_Input, {
    placeholder: "Filter by ".concat(tooltipText, " name or ").concat(tooltipText, " ID"),
    onChange: function onChange(e) {
      return debouncedSetFilterParam(e.target.value);
    }
  }));
};
var fetchProjectsByUser = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(userId, projectType) {
    var _getProjectTypeConfig2, projectTypeDb, response;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          // mismatch between UI and db conventions.
          _getProjectTypeConfig2 = getProjectTypeConfig(projectType), projectTypeDb = _getProjectTypeConfig2.dbType;
          _context2.prev = 1;
          _context2.next = 4;
          return fetchAPI("/v2/user/".concat(userId, "/projects/").concat(projectTypeDb), {
            method: 'GET'
          });
        case 4:
          response = _context2.sent;
          return _context2.abrupt("return", response);
        case 8:
          _context2.prev = 8;
          _context2.t0 = _context2["catch"](1);
          console.error(_context2.t0);
        case 11:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[1, 8]]);
  }));
  return function fetchProjectsByUser(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();
var getUserSearchRegex = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(searchBy, projectType) {
    var projectIds;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          if (validateInput(searchBy, rules.VALID_UUID).isValid || validateInput(searchBy, rules.VALID_EMAIL).isValid) {
            _context3.next = 2;
            break;
          }
          return _context3.abrupt("return");
        case 2:
          _context3.prev = 2;
          _context3.next = 5;
          return fetchProjectsByUser(searchBy, projectType);
        case 5:
          projectIds = _context3.sent;
          if (!(projectIds.length > 0)) {
            _context3.next = 8;
            break;
          }
          return _context3.abrupt("return", new RegExp(projectIds.join('|'), 'i'));
        case 8:
          return _context3.abrupt("return", /^(?!x)x/);
        case 11:
          _context3.prev = 11;
          _context3.t0 = _context3["catch"](2);
          if (!(_context3.t0.response && _context3.t0.response.status === 403)) {
            _context3.next = 15;
            break;
          }
          return _context3.abrupt("return", new RegExp(searchBy, 'i'));
        case 15:
          console.error(_context3.t0);
        case 16:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[2, 11]]);
  }));
  return function getUserSearchRegex(_x4, _x5) {
    return _ref3.apply(this, arguments);
  };
}();
ProjectSearchBox.defaultProps = {
  projectType: null
};
export default ProjectSearchBox;